import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const DomainNamespace_PermissionManager = 'Permission Manager';
export const PermissionManagerPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_PermissionManager, defaultUIAccessLevels);
//Artifacts Jenkins Pipeline
export const ArtifactPipeline_Permission = 'permission-artifact-pipeline';
export const DomainNamespace_ArtifactPipeline = 'Artifact Pipeline';
export const PermissionKey_ArtifactPipelineAccess_Allowed = 'permission-key--developer-viewer';
export const ArtifactPipelineAccess_Allowed = 'Allowed';
export const preDBAccessLevels = [
    Object.freeze({ name: 'Not-Allowed', value: 0 }),
    Object.freeze({ name: ArtifactPipelineAccess_Allowed, value: 100 })
];
export const ArtifactsPipelinePermissionKeysNames = generateKeyNamesByAccessLevel(DomainNamespace_ArtifactPipeline, preDBAccessLevels);
export const PermissionKey_ArtifactsPipelineAllow = 'permission-key--artifacts-pipeline-allow';
export const PermissionKey_ArtifactsPipelineNotAllow = 'permission-key--artifacts-pipeline-not-allow';
//# sourceMappingURL=permission-manager-ui-permissions.js.map